import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const Title = (props) => {
    let subtitle = null;
    if (props.subtitle != null) {
        subtitle = (_jsxs(_Fragment, { children: [_jsx("br", {}), _jsx("small", { className: "text-muted", children: props.subtitle })] }));
    }
    return (_jsxs("h2", { children: [props.title, subtitle] }));
};
export default Title;
